import { graphql } from '@predium/client-graphql';

export const GET_DEFAULT_FEATURE_FLAG_VALUES = graphql(`
  query GetDefaultFeatureFlagValues {
    featureFlagDefaultValues: getDefaultFeatureFlagValues
  }
`);
